<template>
  <v-container class="py-0" fluid>
    <v-row align="center">
      <v-col class="py-1 px-0">
        <p v-if="isCategoryAdvanced && checkboxList === 'hinshi'" class="attention mb-0">※「例文問題」にのみ適用されます。</p>
        <v-checkbox
          v-for="(question, index) in question[checkboxList]"
          :key="index"
          :input-value="inputValue(question)"
          @change="checked(question.value)"
          :label="question.text"
          color="secondary"
          hide-details
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  components: {
  },

  props: {
    checkboxList: {
      type: String,
      default: '',
    }
  },

  methods: {
    checked(value) {
      this.$store.commit('conditions/setCheckList', {
        listName: this.checkboxList,
        value: value
      })
    }
  },

  computed: {
    checkedList() {
      return this.$store.state.conditions.checkedArr[this.checkboxList]
    },
    question() {
      //処理を統一したいのでvalueをすべて配列の形にしている
      return {
        reibun: [
          {text: '適語補充', value: [1]},
          {text: '全文', value: [2]},
        ],
        hanigo: [
          {text: '反意語', value: [1]},
        ],
        target: [
          {text: '連語を含める', value: [2]},
          {text: '既習語を含める', value: [3]},
        ],
        katsuyo: this.$store.state.master.allInflectionalForms,
        hinshi: this.$store.state.master.allSpeechParts,
      }
    },
    inputValue(){
      return function (question) {
        return this.checkedList.includes(question.value[0])
      }
    },
    isCategoryAdvanced() {
      return this.$store.getters['conditions/isCategoryAdvanced']
    },
  },
}
</script>

<style lang="stylus" scoped>
.choice-material
  display flex
  height 106px

  &__checkbox
    margin-top: 22px;

.v-label
  font-weight bold

.attention
  font-size 12px
</style>
